import React from 'react';
import PropTypes from 'prop-types';

class SelectOption extends React.Component {
    constructor(props) {
        super(props);
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    onClickHandler(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    render() {
        return (
            <div
                className={`select-option ${this.props.className}`}
                role="button"
                onClick={this.onClickHandler}
            >
                <span className="select-option-label">
                    {this.props.children}
                </span>
            </div>
        );
    }
}

export default SelectOption;

SelectOption.propTypes = {
    onSelect: PropTypes.func,
    option: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};

SelectOption.defaultProps = {
    onSelect: f => f,
    option: '',
    className: ''
};
